module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "tx"
  }, [_c('i', [_vm._v("“The Russians are a people who historically have needed a belief system to live by,\n\t\t\t\t\twhether Communism or Russian Orthodoxy…they have been uncomfortable with our notion…that\n\t\t\t\t\tthe individual himself is left to develop philosophy, faith, and the meaning of life.”")])]), _vm._v(" "), _c('p', {
    staticClass: "txr"
  }, [_c('i', [_vm._v("Hedrick Smith, "), _c('span', {
    staticClass: "underline",
    attrs: {
      "id": "APM"
    }
  }, [_vm._v("The New Russians")]), _vm._v(", p. xxvi")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a677eeae","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/frontmatter01.vue
// module id = 66
// module chunks = 0